<div class="knowledge__section d-flex flex-column-reverse flex-lg-row justify-content-center">
  <div class="side-1">
    <h2>When it comes to type 1 diabetes risk,<br class="d-none d-lg-block" /> knowledge is power, so stay in the know
    </h2>
    <p>Sign up for our newsletter to hear T1D diagnosis stories, learn about risk factors and get a better understanding
      of how the disease progresses, because you do not want to be caught off guard by an emergency situation.</p>
    <p>We’ll keep you informed and make sure you have the tools to screen it like you mean it.</p>
  </div>
  <div class="side-2">
    <div class="svg-image">
      <img src="/assets/img/sign-up-form/magnifying-glass.svg" class="img-fluid" width="233.77" height="185.53"
        alt="A magnifying glass looking at autoantibodies">
    </div>
  </div>
</div>